import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Shield, LogOut, LayoutDashboard, Users, UserCog, Layers, Calendar, ClipboardList, ClipboardCheck, Sigma, Trophy, Settings } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { ResponsiveShell } from "@/components/ResponsiveShell";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/siswa", icon: Users, label: "Serdik" },
  { to: "/admin/pengasuh", icon: UserCog, label: "Pengasuh" },
  { to: "/admin/kelompok", icon: Layers, label: "Kelompok" },
  { to: "/admin/periode", icon: Calendar, label: "Jadwal Pengisian" },
  { to: "/admin/sosiometri", icon: ClipboardList, label: "Hasil Sosiometri" },
  { to: "/admin/observasi", icon: ClipboardCheck, label: "Hasil Observasi" },
  { to: "/admin/nilai-gabungan", icon: Sigma, label: "Nilai Gabungan" },
  { to: "/admin/ranking", icon: Trophy, label: "Ranking" },
  { to: "/admin/settings", icon: Settings, label: "Setting" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <ResponsiveShell title="Penilaian Serdik" subtitle="Admin Panel" widthClass="w-64" content={<Outlet />}>
        <div className="p-5 border-b border-navy-800">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-sm bg-brass-500 flex items-center justify-center flex-shrink-0">
              <Shield className="w-5 h-5 text-navy-900" />
            </div>
            <div className="min-w-0">
              <div className="font-heading font-bold text-xs uppercase tracking-widest">Penilaian Serdik</div>
              <div className="text-[10px] text-white/40 uppercase tracking-wider mt-0.5">Admin Panel</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 p-2 space-y-0.5 overflow-y-auto">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.to.replace(/\//g, "-").replace(/^-/, "")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${
                    isActive ? "bg-brass-500 text-navy-900 font-semibold" : "text-white/70 hover:bg-navy-800 hover:text-white"
                  }`
                }
              >
                <Icon className="w-4 h-4" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="p-3 border-t border-navy-800">
          <div className="text-[10px] text-white/40 uppercase mb-1">Login sebagai</div>
          <div className="text-sm font-semibold mb-2">{user?.username || user?.nama}</div>
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-navy-800 hover:bg-red-900 text-white/80 hover:text-white text-sm rounded-sm transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </div>
    </ResponsiveShell>
  );
}
